import { useTranslation } from 'react-i18next';

type QueryErrorStateProps = {
  /** User-facing copy only — never pass raw Error.message / stack. */
  message: string;
  onRetry: () => void | Promise<unknown>;
  isRetrying?: boolean;
};

/** Sanitized query failure shell (Screens PR #1 pattern). */
export function QueryErrorState({
  message,
  onRetry,
  isRetrying = false,
}: QueryErrorStateProps) {
  const { t } = useTranslation();
  return (
    <div role="alert" className="space-y-3 rounded-xl border border-bad/30 bg-bad/10 p-4">
      <p className="text-sm text-ink">{message}</p>
      <button
        type="button"
        onClick={() => {
          void onRetry();
        }}
        disabled={isRetrying}
        className="rounded-lg bg-ink px-3 py-1.5 text-sm font-semibold text-white disabled:opacity-60"
      >
        {isRetrying ? t('actions.retrying') : t('actions.retry')}
      </button>
    </div>
  );
}
